<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container">
      <a routerLink="/calculators" class="ph-hero__back">
        <i class="lni lni-arrow-left" aria-hidden="true"></i>
        {{ 'CALCULATORS.BACK' | translate }}
      </a>
      <h1 class="ph-hero__title">{{ 'CALCULATOR4.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'CALCULATOR4.TEXT' | translate }}</p>
    </div>
  </section>

  <section id="calculator" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-calc-layout">
        <form [formGroup]="formGroup" (ngSubmit)="calculate()" class="ph-calc-form-card ph-calc-form">
          <div class="ph-field-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'CALCULATOR4.MONTHLY_RENT' | translate }}</mat-label>
              <input type="number" formControlName="monthlyRent" matInput />
            </mat-form-field>
            <button type="button" class="ph-field-row__info"
              [matTooltip]="'CALCULATOR4.MONTHLY_RENT_INFO' | translate"
              matTooltipPosition="right">
              <i class="lni lni-information"></i>
            </button>
          </div>
          <div class="ph-field-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'CALCULATOR4.ANNUAL_REPAIR_EXPENSES' | translate }}</mat-label>
              <input type="number" formControlName="annualRepairExpenses" matInput />
            </mat-form-field>
            <button type="button" class="ph-field-row__info"
              [matTooltip]="'CALCULATOR4.ANNUAL_REPAIR_EXPENSES_INFO' | translate"
              matTooltipPosition="right">
              <i class="lni lni-information"></i>
            </button>
          </div>
          <div class="ph-field-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'CALCULATOR4.YEAR' | translate }}</mat-label>
              <select formControlName="selectedYear" matNativeControl>
                <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
              </select>
            </mat-form-field>
            <button type="button" class="ph-field-row__info"
              [matTooltip]="'CALCULATOR4.YEAR_INFO' | translate"
              matTooltipPosition="right">
              <i class="lni lni-information"></i>
            </button>
          </div>
          <div class="ph-field-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'CALCULATOR4.TAX_SYSTEM' | translate }}</mat-label>
              <select formControlName="taxSystem" matNativeControl>
                <option value="real">{{ 'CALCULATOR4.REAL_SYSTEM' | translate }}</option>
                <option value="flat">{{ 'CALCULATOR4.FLAT_SYSTEM' | translate }}</option>
              </select>
            </mat-form-field>
            <button type="button" class="ph-field-row__info"
              [matTooltip]="getTooltipText()"
              matTooltipPosition="right">
              <i class="lni lni-information"></i>
            </button>
          </div>
          <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="!formGroup.valid">
            {{ 'CALCULATOR4.COMPUTE' | translate }}
          </button>
        </form>

        <div class="ph-calc-results">
          <article class="ph-result-card">
            <button type="button" class="ph-result-card__info"
              [matTooltip]="'CALCULATOR4.ANNUAL_INCOME_INFO' | translate" matTooltipPosition="above">
              <i class="lni lni-information"></i>
            </button>
            <div class="ph-result-card__icon"><i class="lni lni-revenue"></i></div>
            <p class="ph-result-card__value">{{ annualIncome | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR4.ANNUAL_INCOME' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR4.YEARLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <button type="button" class="ph-result-card__info"
              [matTooltip]="'CALCULATOR4.TAXABLE_INCOME_INFO' | translate" matTooltipPosition="above">
              <i class="lni lni-information"></i>
            </button>
            <div class="ph-result-card__icon"><i class="lni lni-wallet"></i></div>
            <p class="ph-result-card__value">{{ taxableIncome | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR4.TAXABLE_INCOME' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR4.YEARLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <button type="button" class="ph-result-card__info"
              [matTooltip]="'CALCULATOR4.INCOME_TAX_INFO' | translate" matTooltipPosition="above">
              <i class="lni lni-information"></i>
            </button>
            <div class="ph-result-card__icon"><i class="lni lni-coin"></i></div>
            <p class="ph-result-card__value">{{ incomeTax | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR4.INCOME_TAX' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR4.10_PERCENT' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <button type="button" class="ph-result-card__info"
              [matTooltip]="'CALCULATOR4.HEALTH_INSURANCE_INFO' | translate" matTooltipPosition="above">
              <i class="lni lni-information"></i>
            </button>
            <div class="ph-result-card__icon"><i class="lni lni-heart"></i></div>
            <p class="ph-result-card__value">{{ healthInsurance | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR4.HEALTH_INSURANCE' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR4.CASS' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <button type="button" class="ph-result-card__info"
              [matTooltip]="'CALCULATOR4.TOTAL_TAX_INFO' | translate" matTooltipPosition="above">
              <i class="lni lni-information"></i>
            </button>
            <div class="ph-result-card__icon"><i class="lni lni-stats-up"></i></div>
            <p class="ph-result-card__value">{{ totalTax | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR4.TOTAL_TAX' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR4.YEARLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <button type="button" class="ph-result-card__info"
              [matTooltip]="'CALCULATOR4.NET_INCOME_INFO' | translate" matTooltipPosition="above">
              <i class="lni lni-information"></i>
            </button>
            <div class="ph-result-card__icon"><i class="lni lni-money-protection"></i></div>
            <p class="ph-result-card__value">{{ netIncome | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR4.NET_INCOME' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR4.YEARLY' | translate }}</span>
          </article>
        </div>
      </div>
    </div>
  </section>

  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="c4-name">{{ 'HOME.NAME' | translate }}</label>
          <input id="c4-name" type="text" name="name" [(ngModel)]="contactItem.subject" required [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="c4-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input id="c4-email" type="email" name="email" [(ngModel)]="contactItem.email" required email [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="c4-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea id="c4-message" name="message" rows="4" [(ngModel)]="contactItem.content" required [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">Mesaj trimis! Te contactăm în curând.</p>
      </form>
    </div>
  </section>
</div>
